const env = import.meta.env.VITE_ENV ?? 'local';

const deriveAppOriginFromApiEndpoint = (apiEndpoint: string) => {
  try {
    const url = new URL(apiEndpoint, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');

    if (!/^https?:$/i.test(url.protocol)) {
      return typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    }

    const hostname = url.hostname
      .replace(/^api-/, '')
      .replace(/^api\./, '');

    return `${url.protocol}//${hostname}`;
  } catch {
    return typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
  }
};

const defaultApiEndpoint = env === 'local'
  ? '/api'
  : 'https://as-otd-api-dev.azurewebsites.net/api';

const apiEndpoint = import.meta.env.VITE_API_ENDPOINT ?? defaultApiEndpoint;
const appOrigin = import.meta.env.VITE_APP_ORIGIN ?? deriveAppOriginFromApiEndpoint(apiEndpoint);

export const environment = {
  env,
  authDebug: import.meta.env.VITE_AUTH_DEBUG === 'true',
  authRefreshEnabled: import.meta.env.VITE_AUTH_REFRESH_ENABLED === 'true',
  apiEndpoint,
  appOrigin,
  aad: {
    clientId: import.meta.env.VITE_AAD_CLIENT_ID ?? '',
    tenantId: import.meta.env.VITE_AAD_TENANT_ID ?? '',
    authority: import.meta.env.VITE_AAD_AUTHORITY ?? '',
    apiScope: import.meta.env.VITE_AAD_API_SCOPE ?? '',
    enabled: [
      import.meta.env.VITE_AAD_CLIENT_ID,
      import.meta.env.VITE_AAD_TENANT_ID,
      import.meta.env.VITE_AAD_AUTHORITY,
      import.meta.env.VITE_AAD_API_SCOPE,
    ].every((value) => !!value),
  },
  localAuth: {
    enabled: import.meta.env.VITE_LOCAL_AUTH_ENABLED !== 'false',
    userId: import.meta.env.VITE_LOCAL_AUTH_USER_ID ?? 'local.user@localhost',
    role: import.meta.env.VITE_LOCAL_AUTH_ROLE ?? 'admin',
    region: import.meta.env.VITE_LOCAL_AUTH_REGION ?? 'NA',
    product: import.meta.env.VITE_LOCAL_AUTH_PRODUCT ?? 'SLOTD',
    expiresOn: import.meta.env.VITE_LOCAL_AUTH_EXPIRES_ON ?? 'never',
  },
  appInsights: {
    instrumentationKey: import.meta.env.VITE_APP_INSIGHTS_KEY ?? 'none',
    loggingLevel: Number(import.meta.env.VITE_APP_INSIGHTS_LOGGING_LEVEL ?? 2),
  },
  globalTimeout: 60_000,
  downloadTimeout: 180_000,
  uploadTimeout: 180_000,
  inventoryTimeout: 180_000,
} as const;